var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIconActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666016,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#20acd9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8496 15.1018C23.8496 16.8602 22.4241 18.2856 20.6657 18.2856C18.9073 18.2856 17.4819 16.8602 17.4819 15.1018C17.4819 13.3434 18.9073 11.918 20.6657 11.918C22.4241 11.918 23.8496 13.3434 23.8496 15.1018Z",
    stroke: "white",
    strokeWidth: 1.46946,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.543 26.4901C14.543 23.8526 16.6811 21.7144 19.3187 21.7144H22.0127C24.6503 21.7144 26.7885 23.8526 26.7885 26.4901C26.7885 27.3693 26.0758 28.0821 25.1966 28.0821H16.1349C15.2557 28.0821 14.543 27.3693 14.543 26.4901Z",
    stroke: "white",
    strokeWidth: 1.46946,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconActive);
export default __webpack_public_path__ + "static/media/userIconActive.1082a2c68485e1312b14c371eba96adb.svg";
export { ForwardRef as ReactComponent };